var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.$route.meta.fullScreen)?_c('NavBar'):_vm._e(),(_vm.$route.meta.fullScreen)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }